import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const TimerComponent = ({
  initialTime = { day: 0, hour: 0, minute: 0, second: 0 },
}) => {
  const [remainingTime, setRemainingTime] = useState(initialTime);
  const { t } = useTranslation();

  useEffect(() => {
    setRemainingTime(initialTime);
  }, [initialTime]);

  useEffect(() => {
    const decrementTime = () => {
      setRemainingTime((prevTime) => {
        let { day, hour, minute, second } = prevTime;

        if (second > 0) {
          second -= 1;
        } else {
          if (minute > 0) {
            minute -= 1;
            second = 59;
          } else {
            if (hour > 0) {
              hour -= 1;
              minute = 59;
              second = 59;
            } else {
              if (day > 0) {
                day -= 1;
                hour = 23;
                minute = 59;
                second = 59;
              }
            }
          }
        }

        return { day, hour, minute, second };
      });
    };

    const interval = setInterval(decrementTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatNumber = (num) => String(num).padStart(2, "0");

  const TimerBox = ({ value, label }) => (
    <div className="flex flex-col items-center">
      <div className="text-[#00e676] text-4xl font-bold font-mono tracking-wider drop-shadow-[0_0_10px_rgba(0,230,118,0.5)]">
        {formatNumber(value)}
      </div>
      <div className="text-white/60 text-[10px] uppercase font-bold tracking-tighter mt-1">
        {t(label)}
      </div>
    </div>
  );

  return (
    <div className="flex items-center justify-center gap-6 py-4">
      <TimerBox value={remainingTime.second} label="Seconds" />
      <div className="h-8 w-[1px] bg-white/10 mt-[-10px]" />
      <TimerBox value={remainingTime.minute} label="Minutes" />
      <div className="h-8 w-[1px] bg-white/10 mt-[-10px]" />
      <TimerBox value={remainingTime.hour} label="Hours" />
      <div className="h-8 w-[1px] bg-white/10 mt-[-10px]" />
      <TimerBox value={remainingTime.day} label="Days" />
    </div>
  );
};

export default TimerComponent;
